export default class Reiseart {
    public reiseart_id: number | null = null;
    public reiseart: string | null = null;
    public bezeichnung: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Reiseart>) {
        Object.assign(this, data);
    }
}
